var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.542 31.625C14.736 32.097 13.958 32.1247 13.208 31.708C12.458 31.2913 12.083 30.6527 12.083 29.792V10.042C12.083 9.18068 12.458 8.54168 13.208 8.12501C13.958 7.70835 14.736 7.73601 15.542 8.20801L30.958 18.083C31.6807 18.5277 32.042 19.146 32.042 19.938C32.042 20.7293 31.6807 21.3333 30.958 21.75L15.542 31.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1b346cc6317673a2328d495dd060957c.svg";
export { ForwardRef as ReactComponent };